import { MenuItem, Select } from "@mui/material";
import { Button } from "components/atoms/Button";
import NumberInput from "components/atoms/NumberInput/NumberInput";
import { Header } from "components/atoms/Typography";
import MUITheme from "components/MUITheme";
import "./index.scss";
import { Delete } from "components/atoms/Icon";

const END_USES = [
    { value: "skin_heating", label: "Skin heating" },
    { value: "outdoor_air_heating", label: "Outdoor air heating" },
    { value: "skin_cooling", label: "Skin cooling" },
    { value: "outdoor_air_cooling", label: "Outdoor air cooling" },
    { value: "domestic_hot_water", label: "Domestic hot water" },
    { value: "lighting", label: "Lighting" },
    { value: "plug_load", label: "Plug load" },
    { value: "refrigeration", label: "Refrigeration" },
    { value: "fans", label: "Fans" },
    { value: "pumps", label: "Pumps" },
];

function LoadReductionView({
    loadReduction,
    updateEffect,
    deleteEffect,
}: {
    loadReduction: LoadReductionEffect;
    updateEffect: (loadReductionEffect: LoadReductionEffect) => void;
    deleteEffect: () => void;
}) {
    return (
        <div className="effect-container">
            <div className="effect-header">
                <Header size="medium">Load reduction</Header>
                <Button onClick={() => deleteEffect()} icon={<Delete />} />
            </div>
            <Header size="small">End use</Header>
            <MUITheme>
                <Select
                    value={loadReduction.endUse}
                    onChange={(e) =>
                        updateEffect({
                            ...loadReduction,
                            endUse: e.target.value,
                        })
                    }
                    style={{
                        width: "100%",
                        height: "35px",
                        minWidth: 0,
                        backgroundColor: "white",
                    }}
                    required
                >
                    {END_USES.map((unit) => (
                        <MenuItem key={unit.value} value={unit.value}>
                            {unit.label}
                        </MenuItem>
                    ))}
                </Select>
            </MUITheme>
            <Header size="small">Reduction percentage</Header>
            <NumberInput
                key="loadReductionPercentage"
                required={false}
                value={loadReduction.percentReduction || ""}
                className="filter-input"
                onChange={(e) => {
                    if (e.target.value === "") {
                        updateEffect({
                            ...loadReduction,
                            percentReduction: null,
                        });
                    }
                    if (e.target.value === "-") {
                        updateEffect({
                            ...loadReduction,
                            percentReduction: e.target.value,
                        });
                    }
                    const loadReductionPercentage = Number(e.target.value);
                    updateEffect({
                        ...loadReduction,
                        percentReduction: loadReductionPercentage,
                    });
                }}
                placeholder="Enter the percentage of load reduction"
            />
        </div>
    );
}

function LoadreductionEffectInput({
    effects,
    setEffects,
}: {
    effects: LoadReductionEffect[];
    setEffects: (inputs: LoadReductionEffect[]) => void;
}) {
    const addEffect = () => setEffects([...effects, { percentReduction: null, endUse: "", uid: crypto.randomUUID() }]);
    const removeEffect = (uid: string) => () => setEffects(effects.filter((effect) => effect.uid !== uid));
    const updateEffect = (uid: string) => (newEffect: LoadReductionEffect) =>
        setEffects(effects.map((effect) => (effect.uid === uid ? newEffect : effect)));

    return (
        <div>
            {effects.map((loadReduction) => (
                <div key={loadReduction.uid}>
                    <LoadReductionView
                        key={loadReduction.uid}
                        loadReduction={loadReduction}
                        updateEffect={updateEffect(loadReduction.uid)}
                        deleteEffect={removeEffect(loadReduction.uid)}
                    />
                </div>
            ))}
            <div className="filter-container">
                <Button type="primary" onClick={addEffect}>
                    + Add load reduction
                </Button>
            </div>
        </div>
    );
}

export default LoadreductionEffectInput;
